module.exports = __webpack_public_path__ + "static/Dart-f07ae6f792faa9743c97e8a3fead0544.png";